export default "__VITE_ASSET__AnxBPL7b__"